import axiosInstance from "@/lib/axios.instance";

export interface AiDraftRequest {
    document_id: string;
    text_selected: string;
    [key: string]: any;
}

export enum AiDraftOption {
    WriteClause = 'write_clause',
    WriteDefinition = 'write_definition',
    MakeShorter = 'make_shorter',
    MakeLonger = 'make_longer',
    SimplifyLanguage = 'simplify_language',
    ComplexifyLanguage = 'complexify_language',
    Summarise = 'summarizer',
}

export interface AiDraftResponse {
    response: string;
}

export const aiDraft = async (option: AiDraftOption, data: AiDraftRequest): Promise<AiDraftResponse> => {
    const response = await axiosInstance.post(`/ai/draft/${option}`, data);
    return response.data;
};
